<div #formContainer>
    <div *ngIf="activeGroup" [ngClass]="{'disabled--loading': disabled}">
        <app-progress-bar [progress]="groups.indexOf(activeGroup) + 1" [total]="groups.length" trackChanges="true" scoreType="good"></app-progress-bar>
        <div class="wizard__step" [@enterAnimation]="activeGroup">
            <h2 class="wizard__title">{{activeGroup.title}}</h2>
            <dynamic-form (submit)="submitStep($event)" #dynamicForm [fields]="fields" [groupValidators]="groupValidators"></dynamic-form>
        </div>
    </div>
</div>